import { useState } from 'react';
import { DailyChallenge } from '../components/DailyChallenge/DailyChallenge';
import { Board } from '../components/Board/Board';
import { ProblemCard } from '../components/ProblemCard/ProblemCard';
import { useProblem } from '../hooks/useProblem';
import type { HintArea, HintExact } from '../types';

export function DailyPage() {
  const [showBoard, setShowBoard] = useState(false);
  const {
    problem, result, isLoading, hint, hintLevel, solutionPath,
    loadProblem, submitMove, requestHint, showSolution,
  } = useProblem();

  const handleSelectProblem = async (id: string) => {
    await loadProblem(id);
    setShowBoard(true);
  };

  const handleBack = () => {
    setShowBoard(false);
  };

  if (showBoard && problem) {
    const hintArea = hint && 'area' in hint ? (hint as HintArea).area : null;
    const hintCoord = hint && 'coord' in hint ? (hint as HintExact).coord : null;

    return (
      <div className="problem-page">
        <button onClick={handleBack} className="btn btn-back">
          Back to Daily
        </button>
        <Board
          problem={problem}
          onMove={submitMove}
          disabled={!!result?.solved || !!solutionPath}
          opponentMove={result?.opponent_move}
          hintArea={hintArea}
          hintCoord={hintCoord}
          solutionPath={solutionPath}
        />
        <ProblemCard
          problem={problem}
          result={result}
          hintLevel={hintLevel}
          onHint={requestHint}
          onShowSolution={showSolution}
          onNext={handleBack}
        />
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="page-loading">
        <div className="spinner" />
        <p>Loading...</p>
      </div>
    );
  }

  return <DailyChallenge onSelectProblem={handleSelectProblem} />;
}
